import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { BusinessData, TermsAndConditions } from '@app/api/models/api-models';
import { IAnalyticsService } from '@app/api/interfaces/analytics/i.analytics.service';
import { TermsState } from '@app/main/store/reducers/terms-cond.reducers';

@Component({
  selector: 'nav-bar',
  templateUrl: 'nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  standalone: false,
})
export class NavigationBarComponent implements OnInit, OnChanges {
  navbarOpen = false;
  navBarMenu = [
    { id: 'dashboard', link: '/main/dashboard', label: 'csa.navmenu-dashboard', isActive: true, display: true },
    { id: 'profile', link: '/main/profile', label: 'csa.navmenu-profile', isActive: false, display: true },
    { id: 'review', link: '/main/review', label: 'csa.navmenu-review', isActive: false, display: true },
    { id: 'media', link: '/main/media', label: 'csa.navmenu-media', isActive: false, display: false },
  ];
  businessName: string;
  businessAddress: string;

  @Input() business: BusinessData;
  @Input() termsAndConditions: TermsState;
  @Input() isClaimingActive: boolean;
  constructor(
    private readonly router: Router,
    private readonly analyticsService: IAnalyticsService
  ) {}

  ngOnInit() {
    const navBarMenuBasicService = [
      { id: 'dashboard', link: '/main/dashboard', label: 'csa.navmenu-dashboard', isActive: true, display: true, pageType: 'WL_Dashboard' },
      { id: 'profile', link: '/main/profile', label: 'csa.navmenu-profile', isActive: false, display: true, pageType: 'WL_Profile' },
      { id: 'review', link: '/main/review', label: 'csa.navmenu-review', isActive: false, display: true, pageType: 'WL_Reviews' },
      { id: 'posts', link: '/main/posts', label: 'csa.navmenu-post', isActive: false, display: true, pageType: 'WL_Post' },
    ];

    this.navBarMenu = navBarMenuBasicService;
  }

  ngOnChanges() {
    if (this.business) {
      this.businessName = this.business.name;
      this.businessAddress = this.business.street;
      this.setAnalyticsParams();
    }
  }

  toggleNavBar() {
    this.navbarOpen = !this.navbarOpen;
  }

  /**
   * Mark option selected to render specific style.
   * @param menuItem item value.
   */
  isActive(menuItem: any): boolean {
    const { id: section, pageType } = menuItem;
    let isActive = false;
    if (menuItem.link === this.router.url) {
      isActive = true;
      this.analyticsService.setWebListingSection(section);
      this.analyticsService.setPageName();
      this.analyticsService.setPageType(pageType);
    }

    return isActive;
  }

  private setAnalyticsParams() {
    const productVersion = 'basic';
    const { countryCode, establishmentId, zipCode, name, category } = this.business;
    this.analyticsService.setUserCountry(countryCode);
    this.analyticsService.setEstablishmentCountry(countryCode);
    this.analyticsService.setEstablishmentId(establishmentId);
    this.analyticsService.setEstablishmentZipCode(zipCode);
    this.analyticsService.setEstablishmentName(name);
    this.analyticsService.setEstablishmentCategory(category);
    this.analyticsService.setProductVersion(productVersion);
    this.analyticsService.setPageName();
  }
}
